module.exports = __webpack_public_path__ + "img/logo-cjib.svg";